//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/PDM.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AftPerpendicular",0,"Expression",0],[0,"CreateNewItem",1,0],[1,"DesignDraught",0,"Expression",0],[1,"Distance",0,"Expression",0],[0,"ExportNativeFilename",1,0],[1,"ForwardPerpendicular",0,"Expression",0],[1,"FreshWaterDensity",0,"Expression",0],[0,"GZCurve",1,0],[1,"Hull",0,"SelectBodyList",0],[1,"InitialGravityCenterX",0,"Expression",0],[1,"InitialGravityCenterY",0,"Expression",0],[1,"InitialGravityCenterZ",0,"Expression",0],[0,"Level",1,0],[1,"MaxDraught",0,"Expression",0],[1,"MinDraught",0,"Expression",0],[0,"NumberOfSteps",1,0],[1,"SeaWaterDensity",0,"Expression",0],[1,"SingleDraught",0,"Expression",0],[0,"Subdivision",1,0],[1,"ThicknessFactor",0,"Expression",0]],[[["partOperationBuilder"],"SetPartOperationBuilder",{},1,0]],[]];
SPLM.Features.ShipDesign.StabilityBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.StabilityBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.StabilityBuilder.SubdivisionType = Object.freeze({
    "Distance" : "Distance", "NumberOfSteps" : "NumberOfSteps"});

SPLM.Features.ShipDesign.StabilityBuilder.LevelType = Object.freeze({
    "MultipleLevels" : "MultipleLevels", "SingleLevel" : "SingleLevel"});

export default SPLM;